export default __webpack_public_path__ + "static/media/RecreationalVoucher.7b66d99b.png";